import { nanoid } from 'nanoid'

export const generateRandomID = (lenght?: number): string => nanoid(lenght)
